var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPos2Ico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.314,
    height: 42.55,
    viewBox: "0 0 33.314 42.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8863",
    "data-name": "Path 8863",
    d: "M272.312,813.883H268.28l-2.046,3.451-3.329,2.076-.153,3.971-2.122,3.512,2.122,3.512.153,3.971,3.329,2.077,2.046,3.45h4.031l3.574,2.017,3.573-2.017h4.031l2.046-3.45,3.331-2.077.152-3.971,2.123-3.512-2.123-3.512-.152-3.971-3.331-2.076-2.046-3.451h-4.031l-3.573-2.016Z",
    transform: "translate(-260.63 -811.867)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.906,
    y1: 13.554,
    x2: -4.887,
    y2: 13.554,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#507caa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#557cb2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8888",
    "data-name": "Path 8888",
    d: "M265.575,828.823a12.436,12.436,0,1,0,12.435-12.436,12.436,12.436,0,0,0-12.435,12.436",
    transform: "translate(-265.575 -816.387)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -6.132,
    y1: 16.274,
    x2: -6.109,
    y2: 16.274,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5cce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#98a4d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8190c8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8889",
    "data-name": "Path 8889",
    d: "M267.926,829.824a11.085,11.085,0,1,0,11.085-11.086,11.085,11.085,0,0,0-11.085,11.086",
    transform: "translate(-267.926 -818.738)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.94,
    y1: 18.195,
    x2: -6.914,
    y2: 18.195,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aee2fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#73b1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#6faee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6faee0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_875",
    "data-name": "Rectangle 875",
    width: 64.319,
    height: 64.319,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8895",
    "data-name": "Path 8895",
    d: "M272.882,797.734a.409.409,0,0,0-.293.124l-.662.682a.409.409,0,0,0,.075.631l8.637,5.434.007-1.017v-5.853Z",
    transform: "translate(-271.811 -797.734)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_878",
    "data-name": "Rectangle 878",
    width: 48.239,
    height: 46.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8898",
    "data-name": "Path 8898",
    d: "M287.2,797.734v5.853l.007,1.017,8.638-5.434a.409.409,0,0,0,.075-.631l-.662-.682a.408.408,0,0,0-.293-.124Z",
    transform: "translate(-287.195 -797.734)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_881",
    "data-name": "Rectangle 881",
    width: 47.665,
    height: 46.516,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8900",
    "data-name": "Path 8900",
    d: "M284.253,807.53a1.683,1.683,0,1,0,1.683-1.682,1.684,1.684,0,0,0-1.683,1.682",
    transform: "translate(-284.253 -805.848)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -48.507,
    y1: 122.076,
    x2: -48.337,
    y2: 122.076,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdc6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fec041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb22a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    width: 3.365,
    height: 1.947,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6810",
    "data-name": "Group 6810",
    transform: "translate(-620.118 -596.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1763",
    "data-name": "Group 1763",
    transform: "translate(620.118 596.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(1.401 11.117)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_870",
    "data-name": "Rectangle 870",
    width: 30.511,
    height: 30.055,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8864",
    "data-name": "Path 8864",
    d: "M258.19,838.033l2.318,3.835,1.206-.323-2.123-3.513Z",
    transform: "translate(-258.19 -811.89)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8865",
    "data-name": "Path 8865",
    d: "M262.226,844.472l.167,4.335,1.192-.687-.153-3.971Z",
    transform: "translate(-259.908 -814.494)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8866",
    "data-name": "Path 8866",
    d: "M262.516,851.75l1.192-.687,3.329,2.078-.887.877Z",
    transform: "translate(-260.032 -817.437)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8867",
    "data-name": "Path 8867",
    d: "M268.846,855.558l.887-.878,2.046,3.451-.7,1.2Z",
    transform: "translate(-262.727 -818.977)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8868",
    "data-name": "Path 8868",
    d: "M273.434,860.689h4.031l-.328,1.2h-4.4Z",
    transform: "translate(-264.383 -821.535)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M284.3,864.085v-1.379l-3.574-2.017-.328,1.2Z",
    transform: "translate(-267.646 -821.535)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8870",
    "data-name": "Path 8870",
    d: "M313.588,838.033l-2.318,3.835-1.206-.323,2.122-3.513Z",
    transform: "translate(-280.274 -811.89)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8871",
    "data-name": "Path 8871",
    d: "M311.157,844.472l-.167,4.335-1.192-.687.153-3.971Z",
    transform: "translate(-280.161 -814.494)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8872",
    "data-name": "Path 8872",
    d: "M308.522,851.75l-1.192-.687L304,853.141l.887.877Z",
    transform: "translate(-277.693 -817.437)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8873",
    "data-name": "Path 8873",
    d: "M303.371,855.558l-.887-.878-2.046,3.451.7,1.2Z",
    transform: "translate(-276.176 -818.977)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8874",
    "data-name": "Path 8874",
    d: "M297.45,860.689h-4.031l.328,1.2h4.4Z",
    transform: "translate(-273.188 -821.535)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8875",
    "data-name": "Path 8875",
    d: "M287.195,864.085v-1.379l3.574-2.017.328,1.2Z",
    transform: "translate(-270.538 -821.535)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8876",
    "data-name": "Path 8876",
    d: "M258.19,835.191l2.318-3.835,1.206.323-2.123,3.513Z",
    transform: "translate(-258.19 -809.047)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8877",
    "data-name": "Path 8877",
    d: "M262.226,828.142l.167-4.335,1.192.687-.153,3.971Z",
    transform: "translate(-259.908 -805.833)",
    fill: "#556c85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8878",
    "data-name": "Path 8878",
    d: "M262.516,822.126l1.192.687,3.329-2.078-.887-.877Z",
    transform: "translate(-260.032 -804.152)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8879",
    "data-name": "Path 8879",
    d: "M268.846,817.065l.887.878,2.046-3.451-.7-1.2Z",
    transform: "translate(-262.727 -801.359)",
    fill: "#556c85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8880",
    "data-name": "Path 8880",
    d: "M273.434,814.492h4.031l-.328-1.2h-4.4Z",
    transform: "translate(-264.383 -801.359)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8881",
    "data-name": "Path 8881",
    d: "M284.3,809.464v1.379l-3.574,2.017-.328-1.2Z",
    transform: "translate(-267.646 -799.727)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8882",
    "data-name": "Path 8882",
    d: "M313.588,835.191l-2.318-3.835-1.206.323,2.122,3.513Z",
    transform: "translate(-280.274 -809.047)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8883",
    "data-name": "Path 8883",
    d: "M311.157,828.142l-.167-4.335-1.192.687.153,3.971Z",
    transform: "translate(-280.161 -805.833)",
    fill: "#556c85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M308.522,822.126l-1.192.687L304,820.735l.887-.877Z",
    transform: "translate(-277.693 -804.152)",
    fill: "#3d597e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8885",
    "data-name": "Path 8885",
    d: "M303.371,817.065l-.887.878-2.046-3.451.7-1.2Z",
    transform: "translate(-276.176 -801.359)",
    fill: "#556c85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    "data-name": "Path 8886",
    d: "M297.45,814.492h-4.031l.328-1.2h4.4Z",
    transform: "translate(-273.188 -801.359)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8887",
    "data-name": "Path 8887",
    d: "M287.195,809.464v1.379l3.574,2.017.328-1.2Z",
    transform: "translate(-270.538 -799.727)",
    fill: "#5f7795"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    transform: "translate(4.241 13.713)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_872",
    "data-name": "Rectangle 872",
    width: 24.871,
    height: 24.872,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    transform: "translate(5.591 15.063)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_873",
    "data-name": "Rectangle 873",
    width: 22.171,
    height: 22.171,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(5.591 15.063)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    transform: "translate(-21.12 -21.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_874",
    "data-name": "Rectangle 874",
    width: 64.319,
    height: 64.319,
    xlinkHref: "data:image/png;base64,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"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8891",
    "data-name": "Path 8891",
    d: "M290.8,794.209v1.359h-28v-1.359l1.7-1.7h24.6Z",
    transform: "translate(-260.156 -792.509)",
    fill: "#fff2b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    "data-name": "Path 8892",
    d: "M290.8,797.837v1.308l-1.7,1.768h-24.6l-1.7-1.768v-1.308Z",
    transform: "translate(-260.156 -794.777)",
    fill: "#dfa53f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8893",
    "data-name": "Path 8893",
    d: "M289.01,793.438H265.6l-1.618,1.4v2.2l1.618,1.46h23.41l1.618-1.46v-2.2Z",
    transform: "translate(-260.656 -792.904)",
    fill: "#ffc835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8894",
    "data-name": "Path 8894",
    d: "M280.638,804.6,272,799.171a.409.409,0,0,1-.076-.631l.663-.682a.408.408,0,0,1,.293-.123h7.764v5.852Z",
    transform: "translate(-263.989 -794.734)",
    fill: "#ef5717"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(7.822 3.001)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498",
    transform: "translate(-18.183 -21.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_877",
    "data-name": "Rectangle 877",
    width: 48.239,
    height: 46.516,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUAAABSCAYAAAAl8JjiAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAVaADAAQAAAABAAAAUgAAAACcRtGZAAAE+ElEQVR4Ae3bzY4bRRAA4KruHv/Mxut4s0uyq4CSoHAIB3LIhRviGHHiwmvwBCB4gjwJL8AFTrmgCEX8HMgPiGR3s1nZjtf2znimu6heeTkE+tRpzUSqkUa2y+7S7Dc11e2RF4kIZHuzAurNppNsXkBQE9SBoApqAoEEKaVSBTWBQIKUUqmCmkAgQUqpVEFNIJAgpVSqoCYQSJBSKlVQEwgkSCmVKqgJBBKklEoV1AQCCVJKpQpqAoEEKaVSBTWBQIKUUqmCmkAgQUqpVEFNIJAgpVSqoCYQSJBSKlVQEwgkSCmVmgDVJMgZlXIfd/H1BHt08Fb9iLY1leoxeffHo3qf1fqnUU/7R//ax9fv/wf89RPQhtfYhl9SezCPd/i5Nv0jMieF0lkOihTQaomuN3f1cqjstfuV3fpqRuNvN6nN1ds46jnowW2TLXu231OwgRb7ToFxFZLOqGLeouvUaaapnFhdeVw+CW5vfAgwat/v6xtHLb7eUA++v2T6GeXFKV3saHqHmbYYNfeXMlkoCGHGfWCKQLMOqEWWUfHCmNUHP6w8buuqtnFU3y+5SjuYw7B2tAtI1xnqXe4HW9ZBpjWUaGHMsEfgdwfHoGlqjJ67GRS7P9cVf961qR20Yvbv7jhczRVqJFMTcgegizzdMzBsMiLy87ljTNRwgAjP+TP7WLqjbobTySdq+VfeWQHu2rbANj7788QDy4lyxlHlNJwi0glX3gkQFHxwhkFHvL+HCm7x648swW1F8CFPYjcKTZcnBQyuPqo6fqWw7s88vNmt8Ur1M/nxXWNvTMqyJO6bTu07xmRc4kolckBcnVse1xFc0AhDfmfA7aDPe9YloHIP7aPDnr0KNQ/l09Hw1nil+kv20ztH7tnDTmkrM+M5/4VR9IR76u+M9ysC/sHPnzPVnK0yju0w9nXuCTc5do1XBju1dRuDnjM/frHh17r88Wa3xlH9n9/7ckm3FqUtciwuIE5tpQ4Y7QmX3G9K0UOH8ItCeMwV+5JB/cSU83uX+OC3AXFIJXb92nZ4YhsH9X9P45e/Pwi/1twb8zV+L7fLB3m5fNazKlcVVLZwpBZcna+4C7zyj4pnJJ66Bvy85v6guBdro0mrmslbsrUDdQ3b+wZojLu8rqrdnx9nbqSxWgCWqnKLGuGE++mUu+wxT1bbTMjzFUy5rxa2xpr/d7HxXnp+TtuDuj6is2XR5Kxqa65a99RX7aZa+aq1oObgaGwUbPOqv8uX/5wreKxrOh3kaB8PdCtgG1/8n5/d/3tcTzrIVWtG2mYLrXJbuQGvBwaGqMtL2Mopmna5D7vLsLzyna34pPgVQKNbq1HPZCaIxb0cuWrV39Q1dYkdKuruasXtVIHb6Kiybd+s2o+6rrnzquVbgurK+7XOR06VLxWVfXT/3mBpyX3X1vXU0HW7/gpKd3gi27o7c/ylgT/qwH8jG99v163At6ZSQ9htjLdi8d9GmJhjEtQYvcBYQQ3AxIQFNUYvMFZQAzAxYUGN0QuMFdQATExYUGP0AmMFNQATExbUGL3AWEENwMSEBTVGLzBWUAMwMWFBjdELjBXUAExMWFBj9AJjBTUAExMW1Bi9wFhBDcDEhAU1Ri8wVlADMDFhQY3RC4wV1ABMTFhQY/QCYwU1ABMTFtQYvcBYQQ3AxIQFNUYvMFZQAzAxYUGN0QuMFdQATEz4H5F38FV5LLjlAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8896",
    "data-name": "Path 8896",
    d: "M276.351,797.735l6.227,4.1v-1.8l-3.583-2.3Z",
    transform: "translate(-265.922 -794.734)",
    fill: "#fed2bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8897",
    "data-name": "Path 8897",
    d: "M287.2,804.6l8.637-5.434a.409.409,0,0,0,.076-.631l-.663-.682a.408.408,0,0,0-.293-.123H287.2v5.852Z",
    transform: "translate(-270.538 -794.734)",
    fill: "#eb3f1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(16.657 3.001)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(-20.7 -21.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_880",
    "data-name": "Rectangle 880",
    width: 47.665,
    height: 46.516,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABSCAYAAADKMvPcAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAVKADAAQAAAABAAAAUgAAAAAb4BraAAAExUlEQVR4Ae3bS28jRRAH8Krutj2xHfLcbLIbshu0AgUuaLUcEBcu3PYzgcQn4JNwAU5w4IDEZYX2gDhwIJDnbh6OX7HHnpkuahJb4qU+tBpNR6qR4sRT7krn53/PI0qQiEC2cAIqXCvpVAoIaOAcCKiABhYI3E4SKqCBBQK3k4QKaGCBwO0koQIaWCBwO0mogAYWCNxOEiqggQUCt5OECmhggcDtJKECGlggcDtJqIAGFgjcThIqoIEFAreThApoYIHA7SShAhpYIHA7SaiABhYI3E4SKqCBBQK3k4QGBjWB+/1v7U5wC//Z/AGdRvfHrRjzH9z+BbHEnH9A8jyH9GtTYt58xAQbJ+gV4snqZhlI9fuHNd3sWb3QtmaQa4UWsDBgFxNbDFKVb7/Ic36djQU1OtBZKvGXVkNvPMxr1kAyBkoUwoIxUMsIUSvKSdG4lulrq2G89TLPYkGN5xjKqUy/aGLyvKn2jxKzAkUymlBLJbhsMlwmoCVLkBhNYC2MlMXOWNFZA5A4xfbpJ5fzQ0CZ7Mq2KBI6T+WvH9f1+mFRJ4Rm2qZlY+FeoWGryOE+alhjpQQJMpbrKA2HWMD+AsLpGFSPUzrlZW8rk5x941gSipwy0xzaZFinxVoD1vkUtFUoeJNPOztKMSjBYvkfAfxPK31+bm2B56jAjMtDwJTfgki2ykHLdL5YSdQ7xaTRL2BJJ2rTFrRDCh4z5iOm2mStRU4lrybGBEh5/0AhDSzi2KSUTVpoVz/tR0Eaw4U9PnyUm2KKTVJqndV2CXCPE7nHKd1lzHKpK97XQ8Jj3rdvCfcLiyd8Yuo2lu3kYsMUnc/fKI+hlW+VJrRM53cbLXzW5aAtUhMRS7xtRNphuPsslDDoiDEvOJHHXPujIDjgr0+pBpe2o/tHr9Xk/es0msumSkHLOK0/K3Dws1Za8cmIqMnLuc2ADU5qzpdKl7zMz3ixH/BLD0DhsbJ0lgyxywkeXezg9N3fJgXXokhn+fNUDlpOQq/zkZJZ+LhJfOaecAK7YLHHC/2KE3rEqIf8+ZUle6lAD6ZtSHe30/zJ05FNvuQAr/ArItmiAG1dWNu7B1kdYFAAvuakjnjZT9joUls4ZejzREGPeuq6v4HZ4x+zPH1paPWr62gg5+9n5aAfrfXo6K2FIuvAyGhe4nzGIQ1G8RmcptC1DdvVVg9Ty6ncm6Xym7hSOccsP1d+YZ9+1lI/fbtmTEZJNrGtuoHW7QRpUk/VqL5G6VWhb1LJ+ymWe/bbOf77sfLLpvJy570nw/LEMllr00CRukBU5wt91eHry+HSDzbl28r8QedV9Jglb+UJLScxv/XkLxX/UgTNBwRvfz8tbyPLY+SdgOR53mxRgJYzmaHezmr2GPvy/ttkZ0+iAf2vyd3FfZUfQ+8immvOAurS8agJqAeaa4iAunQ8agLqgeYaIqAuHY+agHqguYYIqEvHoyagHmiuIQLq0vGoCagHmmuIgLp0PGoC6oHmGiKgLh2PmoB6oLmGCKhLx6MmoB5oriEC6tLxqAmoB5priIC6dDxqAuqB5hoioC4dj5qAeqC5hgioS8ejJqAeaK4hAurS8agJqAeaa4iAunQ8agLqgeYaIqAuHY+agHqguYb8CT8Fw8BdZ/cYAAAAAElFTkSuQmCC"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8899",
    "data-name": "Path 8899",
    d: "M293.423,797.735l-6.227,4.1v-1.8l3.583-2.3Z",
    transform: "translate(-270.538 -794.734)",
    fill: "#fed2bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514",
    transform: "translate(14.967 7.66)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    width: 3.365,
    height: 3.365,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518",
    transform: "translate(14.968 7.66)",
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8901",
    "data-name": "Path 8901",
    d: "M287.619,807.529a1.607,1.607,0,0,1-.021.264,1.682,1.682,0,0,0-3.322,0,1.607,1.607,0,0,1-.021-.264,1.682,1.682,0,1,1,3.365,0",
    transform: "translate(-284.254 -805.847)",
    fill: "#fce689"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8906",
    "data-name": "Path 8906",
    d: "M283.914,836.433a.076.076,0,0,0,.078.041h4.938a.218.218,0,0,1,.164.073.249.249,0,0,1,.068.176v2.449a.249.249,0,0,1-.068.176.217.217,0,0,1-.164.072h-9.083a.216.216,0,0,1-.164-.072.248.248,0,0,1-.068-.176v-2.3a.437.437,0,0,1,.116-.311q1.162-1.162,3.079-3.341l1.162-1.307q1.762-1.95,1.762-2.843a1.314,1.314,0,0,0-.416-1,1.5,1.5,0,0,0-1.075-.394,1.468,1.468,0,0,0-1.065.394,1.381,1.381,0,0,0-.407,1.038v.5a.247.247,0,0,1-.068.176.216.216,0,0,1-.164.073h-2.789a.216.216,0,0,1-.165-.073.247.247,0,0,1-.068-.176v-1.038a3.791,3.791,0,0,1,.717-2.034,4.138,4.138,0,0,1,1.684-1.338,5.639,5.639,0,0,1,2.324-.467,5.274,5.274,0,0,1,2.508.57,4.065,4.065,0,0,1,1.646,1.546,4.207,4.207,0,0,1,.184,3.88,8.758,8.758,0,0,1-1.162,1.847q-.543.706-1.22,1.432t-1.878,1.951l-.387.395a.069.069,0,0,0-.02.083",
    transform: "translate(-267.27 -806.226)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos2Ico);
export default __webpack_public_path__ + "static/media/pos2-ico.b79e154101c0b211d804ccfafb952415.svg";
export { ForwardRef as ReactComponent };